export * from './zahlungseingang-delete-request.interface';
export * from './zahlungseingang-delete-response.interface';
export * from './zahlungseingang-delete.shapes';
